import type { SelfOnboardingStep } from '~/api/seller-self-onboarding/types'
import { ROUTE_NAMES } from '~/constants/routes'

import {
  ONBOARDING_ROUTE_NAMES_MAPPING,
  STEP_STATUS_VARIANT,
} from './OnboardingStep.constants'

const ONBOARDING_LISTING_V2_ROUTES_MAPPING = {
  [ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ACTIVE]:
    ROUTE_NAMES.ONBOARDING.LISTINGSV2.TABS.ACTIVE,
  [ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.MISSING_INFOS]:
    ROUTE_NAMES.ONBOARDING.LISTINGSV2.TABS.ACTIVE,
  [ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.IN_VALIDATION]:
    ROUTE_NAMES.ONBOARDING.LISTINGSV2.TABS.IN_VALIDATION,
  [ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ARCHIVED]:
    ROUTE_NAMES.ONBOARDING.LISTINGSV2.TABS.ARCHIVED,
}

export function formatStep(
  step: SelfOnboardingStep,
  isListingsPageV2Default: boolean,
) {
  const { link } = step
  if (link.type === 'internal') {
    // Optionnaly map the route name from old Pastrami naming to new one
    link.name = ONBOARDING_ROUTE_NAMES_MAPPING[link.name] || link.name

    // If the seller can only see the listings page v2, map the route name to the listings page v2 route name
    if (
      isListingsPageV2Default &&
      Object.keys(ONBOARDING_LISTING_V2_ROUTES_MAPPING).includes(link.name)
    ) {
      link.name = ONBOARDING_LISTING_V2_ROUTES_MAPPING[link.name]
    }
  }

  return {
    title: step.step.label,
    description: step.description,
    estimatedDuration: step.estimatedDuration,
    buttonLabel: step.buttonLabel,
    link,
    targetValue:
      // Why not use step.targetValue directly?
      step.step.code === 'TERMS_AND_CONDITIONS' ? '_blank' : '_self',
    status: {
      label: step.status.label,
      variant: step.required
        ? STEP_STATUS_VARIANT[step.status.code]
        : 'secondary',
    },
    required: step.required,
  }
}
